var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomBefore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: 800,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e9ecef",
    d: "M0 0h800v450H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ced4da",
    d: "m0 450 170-150h460l170 150z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb5bd",
    d: "M140 70h170v210H140z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8f9fa",
    d: "M150 80h150v190H150z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#868e96",
    d: "M455 160h200v140H455z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dee2e6",
    d: "M465 170h180v120H465z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBefore);
export default __webpack_public_path__ + "static/media/room-before.b3773d6e544f0afb56f16d9839dcbcba.svg";
export { ForwardRef as ReactComponent };